module.exports = function (e) {
  var t = {};
  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }
  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 2);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.generateScript = t.generateAPIName = t.destroyBot = void 0, t.destroyBot = function (e) {
    var t,
      r,
      n = null === (r = null === (t = window.Leadoo) || void 0 === t ? void 0 : t.Custom) || void 0 === r ? void 0 : r[e];
    return n ? n.destroy() : Promise.resolve();
  }, t.generateAPIName = function () {
    return "_reactBot".concat(Math.floor(999999 * Math.random()));
  }, t.generateScript = function (e) {
    var t = document.createElement("script");
    return t.src = e, t;
  };
}, function (e, t, r) {
  "use strict";

  var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
      void 0 === n && (n = r), Object.defineProperty(e, n, {
        enumerable: !0,
        get: function get() {
          return t[r];
        }
      });
    } : function (e, t, r, n) {
      void 0 === n && (n = r), e[n] = t[r];
    }),
    o = this && this.__exportStar || function (e, t) {
      for (var r in e) {
        "default" === r || t.hasOwnProperty(r) || n(t, e, r);
      }
    };
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u = r(3);
  Object.defineProperty(t, "InPageBot", {
    enumerable: !0,
    get: function get() {
      return u.InPageBot;
    }
  });
  var i = r(4);
  Object.defineProperty(t, "VisualBot", {
    enumerable: !0,
    get: function get() {
      return i.VisualBot;
    }
  }), o(r(5), t);
}, function (e, t, r) {
  "use strict";

  function n(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
        n = !0,
        o = !1,
        u = void 0;
      try {
        for (var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        o = !0, u = e;
      } finally {
        try {
          n || null == a.return || a.return();
        } finally {
          if (o) throw u;
        }
      }
      return r;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return o(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return o(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function o(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }
    return n;
  }
  var u = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
      void 0 === n && (n = r), Object.defineProperty(e, n, {
        enumerable: !0,
        get: function get() {
          return t[r];
        }
      });
    } : function (e, t, r, n) {
      void 0 === n && (n = r), e[n] = t[r];
    }),
    i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      });
    } : function (e, t) {
      e.default = t;
    }),
    a = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var r in e) {
        "default" !== r && Object.hasOwnProperty.call(e, r) && u(t, e, r);
      }
      return i(t, e), t;
    };
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.InPageBot = void 0;
  var c = a(r(0)),
    l = r(1),
    f = c.useEffect,
    s = c.useRef,
    d = c.useState,
    p = function p() {};
  t.InPageBot = function (e) {
    var t = e.code,
      r = e.generateScript,
      o = void 0 === r ? l.generateScript : r,
      u = e.mediaPartner,
      i = void 0 === u ? null : u,
      a = e.seamless,
      v = void 0 !== a && a,
      b = n(d(l.generateAPIName()), 2),
      y = b[0],
      m = b[1],
      h = n(d(null), 2),
      g = h[0],
      j = h[1],
      _ = s(null),
      O = s(null);
    return f(function () {
      y && j(function (e, t, r, n) {
        var o;
        o = n ? "".concat("https://bot.leadoo.com").concat("/bot/mp/inpage.js?code=").concat(e, "&media=").concat(encodeURIComponent(n)) : "".concat("https://bot.leadoo.com").concat("/bot/inpage.js?code=").concat(e);
        var u = ["api=".concat(t)];
        return r && u.push("seamless"), u.length > 0 && (o = "".concat(o, "#").concat(u.join(","))), o;
      }(t, y, v, i));
    }, [y]), f(function () {
      if (!_.current || !g) return p;
      var e = O.current = o(g);
      return _.current.appendChild(e), function () {
        l.destroyBot(y).catch(function (e) {
          console.error("Failed cleaning up bot:", e);
        }), m(l.generateAPIName());
      };
    }, [g, _.current]), c.createElement("div", {
      ref: _
    });
  };
}, function (e, t, r) {
  "use strict";

  function n(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
        n = !0,
        o = !1,
        u = void 0;
      try {
        for (var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        o = !0, u = e;
      } finally {
        try {
          n || null == a.return || a.return();
        } finally {
          if (o) throw u;
        }
      }
      return r;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return o(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return o(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function o(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }
    return n;
  }
  var u = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
      void 0 === n && (n = r), Object.defineProperty(e, n, {
        enumerable: !0,
        get: function get() {
          return t[r];
        }
      });
    } : function (e, t, r, n) {
      void 0 === n && (n = r), e[n] = t[r];
    }),
    i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      });
    } : function (e, t) {
      e.default = t;
    }),
    a = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var r in e) {
        "default" !== r && Object.hasOwnProperty.call(e, r) && u(t, e, r);
      }
      return i(t, e), t;
    };
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.VisualBot = void 0;
  var c = a(r(0)),
    l = r(1),
    f = c.useEffect,
    s = c.useRef,
    d = c.useState,
    p = function p() {};
  t.VisualBot = function (e) {
    var t = e.code,
      r = e.generateScript,
      o = void 0 === r ? l.generateScript : r,
      u = e.seamless,
      i = void 0 !== u && u,
      a = n(d(l.generateAPIName()), 2),
      v = a[0],
      b = a[1],
      y = n(d(null), 2),
      m = y[0],
      h = y[1],
      g = s(null),
      j = s(null);
    return f(function () {
      v && h(function (e, t, r) {
        var n;
        n = "".concat("https://bot.leadoo.com").concat("/bot/visual.js?code=").concat(e);
        var o = ["api=".concat(t)];
        return r && o.push("seamless"), o.length > 0 && (n = "".concat(n, "#").concat(o.join(","))), n;
      }(t, v, i));
    }, [v]), f(function () {
      if (!g.current || !m) return p;
      var e = j.current = o(m);
      return g.current.appendChild(e), function () {
        l.destroyBot(v).catch(function (e) {
          console.error("Failed cleaning up bot:", e);
        }), b(l.generateAPIName());
      };
    }, [m, g.current]), c.createElement("div", {
      ref: g
    });
  };
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
}]);